export default __webpack_public_path__ + "static/media/version.68b46e85.svg";